import moment from 'moment-timezone';

export enum SymbolPosition {
  AFTER = 'after',
  BEFORE = 'before',
}

export enum CountryCode {
  ES = 'ES',
  MX = 'MX',
}

export interface CurrencySettings {
  code: string;
  position: SymbolPosition;
  symbol: string;
  precision: number;
  thousand_separator: string;
  decimal_separator: string;
}

export interface CountrySettings {
  code: CountryCode;
  name: string;
}
export interface GlobalSetting {
  currency: CurrencySettings;
  country: CountrySettings;
  server_time: string;
  client_time: string;
  timezone: string;
}
